// @ts-nocheck
const TaskSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TaskSkeleton